import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

const publicClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

const onboardingService = {
  getPlans: async () => {
    const response = await publicClient.get('/onboarding/plans');
    return response.data;
  },

  initiate: async (data) => {
    const response = await publicClient.post('/onboarding/initiate', data);
    return response.data;
  },

  getStatus: async (reference) => {
    const response = await publicClient.get(`/onboarding/status/${reference}`);
    return response.data;
  },

  verifyRedirect: async (params) => {
    const response = await publicClient.get('/onboarding/verify-redirect', { params });
    return response.data;
  },

  validateCoupon: async (code) => {
    const response = await publicClient.post('/onboarding/validate-coupon', { code });
    return response.data;
  },
};

export default onboardingService;
